import { render } from "./Done.vue?vue&type=template&id=2f2866b0&scoped=true"
import script from "./Done.vue?vue&type=script&lang=js"
export * from "./Done.vue?vue&type=script&lang=js"

import "./Done.vue?vue&type=style&index=0&id=2f2866b0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2f2866b0"

export default script